import onCumulativeLayoutShift from './onCumulativeLayoutShift';
import onFirstContentfulPaint from './onFirstContentfulPaint';
import onInteractionToNextPaint from './onInteractionToNextPaint';
import onLargestContentfulPaint from './onLargestContentfulPaint';
import onTimeToFirstByte from './onTimeToFirstByte';
import type { MetricReport } from '../contracts/metricReport';

const reportMetrics = (report: (m: MetricReport) => void): void => {
  onCumulativeLayoutShift(report);
  onFirstContentfulPaint(report);
  onInteractionToNextPaint(report);
  onLargestContentfulPaint(report);
  onTimeToFirstByte(report);
};

export default reportMetrics;
